import { Flex, Icon } from '@chakra-ui/react'

import { ReactComponent as PixIcon } from '../assets/icons/pixIcon.svg'
import { ReactComponent as SigaPay } from '../assets/icons/sigapayIcon.svg'

const Header = () => {
  return (
    <Flex w="100%" justify="space-between" align="center">
      <Icon w="96px" h="50px" as={SigaPay} />
      <Icon w="72px" h="26px" as={PixIcon} />
    </Flex>
  )
}

export default Header
